// import { GameData } from "../gamestate/gameData";
import { Howl } from "howler";
import { createMovieClip } from "../../functions/Functions_General";
import { generateVersion } from "../../functions/cookies";
import DeviceChecker from "../../functions/helper.ts/DeviceChecker";

export class JumpingCoins {
  private parent: PIXI.Container;
  private displaySize: Array<number>;
  private shockwave: PIXI.Sprite;
  private shockwaveTween: PIXI.tween.Tween;
  private coinsClip: Array<PIXI.extras.AnimatedSprite>;
  private coinsTweenA: Array<PIXI.tween.Tween>;
  private coinsTweenB: Array<PIXI.tween.Tween>;
  private totalCoins: number;
  private coinAngle: number;
  private angleInc: number;
  private coinSound: Howl;
  private loop: boolean;

  private parentTween: PIXI.tween.Tween;
  constructor(
    parent: PIXI.Container,
    displaySize: Array<number>,
    totalCoins: number
  ) {
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);
    this.displaySize = displaySize;
    this.createShockwave();
    this.totalCoins = totalCoins;
    this.coinsClip = [];
    this.coinsTweenA = [];
    this.coinsTweenB = [];
    this.coinAngle = 0;
    this.angleInc = 0;
    this.loop = false; //default set false;
    for (let index = 0; index < this.totalCoins; index++) {
      this.createMovieClip(index);
      this.createTweens(index);
    }

    this.coinSound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/18934993_coins_edited.m4a?" + "version=" + generateVersion(),
      ],
      volume: 1,
      sprite: {
        coinSplash: [0, 2000],
      },
    });
    this.setloop(false);

    //-

    // this.startJump();

    // this.setloop(true);
  }

  public startJump = (): void => {
    //
    // console.log("coinsAnimation")
    this.stop();

    for (let index = 0; index < this.totalCoins; index++) {
      this.coinsTweenA[index].start();
      this.coinsClip[index].gotoAndPlay(
        Math.random() * this.coinsClip[index].totalFrames
      );
      this.coinsClip[index].alpha = 1;
    }
    if (this.coinSound.playing() == false) {
      this.coinSound.play("coinSplash");
    }

    this.startShockWave();
    // setTimeout(function(){
    //     this.startJump()
    // }.bind(this),3000);
  };

  private stopSelected = (index: number): void => {
    this.coinsTweenA[index].stop();
    this.coinsTweenA[index].reset();

    this.coinsTweenB[index].stop();
    this.coinsTweenB[index].reset();
    this.coinsClip[index].position.set(-200);
    this.coinsClip[index].alpha = 0;
  };
  public stop = (): void => {
    //stop everything
    for (let index = 0; index < this.totalCoins; index++) {
      this.coinsTweenA[index].stop();
      this.coinsTweenA[index].reset();

      this.coinsTweenB[index].stop();
      this.coinsTweenB[index].reset();
      this.coinsClip[index].position.set(-200);
      this.coinsClip[index].alpha = 0;
    }

    this.stopShockWave();
    this.coinSound.stop();
  };

  private createShockwave = (): void => {
    this.shockwave = new PIXI.Sprite(PIXI.Texture.fromFrame("ZoomingFx.png"));
    // this.shockwave.tint=(0xff5500)
    this.shockwave.anchor.set(0.5);
    this.shockwave.position.set(
      this.displaySize[0] / 2,
      this.displaySize[1] / 2
    );
    this.parent.addChild(this.shockwave);
    this.shockwave.blendMode = PIXI.BLEND_MODES.ADD;

    this.shockwaveTween = PIXI.tweenManager.createTween(this.shockwave);
    this.shockwaveTween
      .from({ scale: { x: 3, y: 3 }, alpha: 1 })
      .to({ scale: { x: 8, y: 8 }, alpha: 0 });
    this.shockwaveTween.time = 2500;
    this.shockwaveTween.easing = PIXI.tween.Easing.outExpo();
    this.shockwaveTween.loop = false;
    this.stopShockWave();

    this.parent.pivot.set(this.displaySize[0] / 2, this.displaySize[1] / 2);
    this.parent.position.set(this.displaySize[0] / 2, this.displaySize[1] / 2);
    this.parentTween = PIXI.tweenManager.createTween(this.parent);
    this.parentTween
      .from({ scale: { x: 1, y: 1 }, alpha: 1 })
      .to({ scale: { x: 0.5, y: 0.5 }, alpha: 0 });
    this.parentTween.time = 2500;
    this.parentTween.easing = PIXI.tween.Easing.inExpo();
    this.parentTween.loop = false;
  };

  private startShockWave = (): void => {
    this.stopShockWave();
    this.shockwaveTween.start();
    // console.log('SHOCKWAAVE')
    // this.parentTween.start();
  };
  private stopShockWave = (): void => {
    this.shockwaveTween.stop();
    this.shockwaveTween.reset();
    this.shockwave.alpha = 0;
    this.shockwave.scale.set(0);
  };

  private createMovieClip = (index: number): void => {
    // let frames = [];
    // for (var i = 0; i < 44; i++) {
    //     if (i < 10) {
    //         frames.push(PIXI.Texture.fromFrame('coins_0000' + i + '.png'));

    //     }
    //     else {
    //         frames.push(PIXI.Texture.fromFrame('coins_000' + i + '.png'));
    //     }
    // }
    // this.coinsClip[index] = new PIXI.extras.AnimatedSprite(frames);
    this.coinsClip[index] = createMovieClip("coins", 0, 44);
    this.coinsClip[index].anchor.set(0.5);
    this.coinsClip[index].animationSpeed = Math.random() * 0.1 + 0.1;
    this.coinsClip[index].loop = true;
    this.coinsClip[index].scale.set((index / this.totalCoins) * 0.5 + 0.5);
    this.coinsClip[index].anchor.set(0.5);
    this.coinsClip[index].alpha = 0;

    this.parent.addChild(this.coinsClip[index]);
    // this.coinsClip[index].position.set(this.displaySize[0]/2ex, this.displaySize[1]/2);
  };

  private createTweens = (index: number): void => {
    let radius = Math.random() * 500 + 500;

    let randomx = radius * Math.cos(-this.coinAngle) + this.displaySize[0] / 2;
    let randomy = radius * Math.sin(-this.coinAngle) + this.displaySize[1] / 2;
    this.coinsTweenA[index] = PIXI.tweenManager.createTween(
      this.coinsClip[index]
    );
    this.coinsTweenA[index]
      .from({
        x: this.displaySize[0] / 2,
        y: this.displaySize[1] / 2,
        rotation: (Math.random() * 360 * Math.PI) / 180,
      })
      .to({
        x: randomx,
        y: randomy,
        rotation: (Math.random() * 360 * Math.PI) / 180,
      });
    // this.coinsTweenA[index].delay=Math.random()*1000+;
    this.coinsTweenA[index].time = Math.random() * 600 + 1000;
    this.coinsTweenA[index].delay = index * 3;
    this.coinsTweenA[index].easing = PIXI.tween.Easing.outExpo();
    // this.coinsTweenA[index].loop=true;
    // this.coinsTweenA[index].start();
    // this.coinsTweenA[index].delay=1*index+Math.random()*1000;

    this.coinsTweenB[index] = PIXI.tweenManager.createTween(
      this.coinsClip[index]
    );
    this.coinsTweenB[index]
      .from({
        x: randomx,
        y: randomy,
        rotation: this.coinsClip[index].rotation,
      })
      .to({
        x: randomx,
        y: randomy + 2080,
        rotation: (-Math.random() * 360 * Math.PI) / 180,
      });

    this.coinsTweenB[index].time = 2000;
    this.coinsTweenB[index].easing = PIXI.tween.Easing.inExpo();

    this.coinsTweenA[index].on(
      "update",
      function(
        tween: PIXI.tween.Tween,
        sprite: PIXI.extras.AnimatedSprite,
        elapsedTime: number
      ) {
        if (elapsedTime > 0.8) {
          this.stop();
          tween.from({
            x: this.target.position.x,
            y: this.target.position.y,
            rotation: 0,
          });
          sprite.animationSpeed = 0.4;
          tween.start();
        }
      }.bind(
        this.coinsTweenA[index],
        this.coinsTweenB[index],
        this.coinsClip[index]
      )
    );

    this.angleInc += 180 / this.totalCoins;
    this.coinAngle += ((this.angleInc * Math.PI) / 180) % Math.PI;
    // console.log(this.coinAngle)

    if (this.loop) {
      this.loopCoinsAnimation();
    }
  };

  public setloop = (bool: boolean): void => {
    if (bool) {
      this.loopCoinsAnimation();
    } else {
      for (let i = 0; i < this.coinsTweenB.length; i++) {
        this.coinsTweenB[i].on(
          "end",
          function(self: JumpingCoins, index: number) {
            self.stopSelected(index);
          }.bind(this.coinsTweenB[i], this, i)
        );
      }
    }
  };

  private loopCoinsAnimation = (): void => {
    this.coinsTweenB[this.coinsTweenB.length - 1].on(
      "end",
      function(self: JumpingCoins) {
        self.stop();
        self.startJump();
        // self.activeGameData.mainGame.gameOverScreen.displayGameOver(self.activeGameData)
      }.bind(this.coinsTweenB[this.coinsTweenB.length - 1], this)
    );

    this.coinsTweenA[0].on(
      "start",
      function(self: JumpingCoins) {
        // console.log('STARRT')

        self.startShockWave();
      }.bind(this.coinsTweenA[0], this)
    );
  };
  public getCoinSound = (): Howl => {
    return this.coinSound;
  };
}
